/* eslint-disable no-param-reassign */
import {createNewJsonObject, ConvertSecondsToHHMMSS} from '@/libs/appHelper';
import {consoleLog} from '@/libs/consoleHelper';

import {PRESSURIZED_CODE} from '../constant/pressureContentConstant';
import {
  SEQUENCE_TYPE_ALL,
  SEQUENCE_TYPE,
  SEQUENCE_TYPE_ALL_ENUM,
  RUN_TIME_MODE,
} from '../constant/sequenceContentConstants';

import {findSequenceIndex, ConvertRepeatModeFromBE} from './commonFunction';
import {CalcTimeEachSequence, AddSequence} from './sequenceContent';

export const ConvertStatusOperationsToUIOperations = (operationsBackendStatus, operationsUI) => {
  operationsUI = createNewJsonObject(operationsUI);
  operationsBackendStatus = createNewJsonObject(operationsBackendStatus);
  const operationsBackendStatusLength = operationsBackendStatus.length;
  let indexArray = -100;
  for (let i = 0; i < operationsBackendStatusLength; i++) {
    const operation = operationsBackendStatus[i];

    if (operation.Running === false) {
      const RunningId = operation.Id.toString();
      if (RunningId !== '-1') {
        indexArray = findSequenceIndex(operationsUI, RunningId);
        if (operationsUI[indexArray] !== undefined) {
          operationsUI[indexArray].Running = operation.Running;
        }
      }
      continue;
    }

    if (operation.Running === true) {
      const RunningId = operation.Id.toString();
      if (RunningId === '-1') {
        operationsUI = ResetAllSequenceRunning(operationsUI);
        if (operation.Sequence === SEQUENCE_TYPE_ALL[SEQUENCE_TYPE_ALL_ENUM.PRESSURE_CHANGE.FE].value) {
          indexArray = PRESSURIZED_CODE.PRESSURIZED.CODE;
        } else if (operation.Sequence === SEQUENCE_TYPE_ALL[SEQUENCE_TYPE_ALL_ENUM.DEPRESSURIZED_PRESSURE.FE].value) {
          indexArray = PRESSURIZED_CODE.DEPRESSURIZED.CODE;
        }
      } else {
        operationsUI = ResetAllSequenceRunning(operationsUI);
        indexArray = findSequenceIndex(operationsUI, RunningId);
        if (operationsUI[indexArray] !== undefined) {
          operationsUI[indexArray].Running = true;
          operationsUI[indexArray].Repeated = operation.Repeated;
          operationsUI[indexArray].Repeat = operation.Repeat;
        }
      }

      break;
    }
  }

  return {operationsUI, indexArrayRunning: indexArray};
};

export const ConvertBEOperationsToUIOperations = (operationsBackendStatus, operationsUI, defaultSequenceTemplate) => {
  operationsBackendStatus = createNewJsonObject(operationsBackendStatus);
  // operationsUI = createNewJsonObject(operationsUI);
  // var newSequence = createNewJsonObject(defaultSequenceTemplate);

  // const operationsBackendStatusLength = operationsBackendStatus.length;
  const indexUI = 0;

  const tempOperation = operationsBackendStatus.filter((operation) => operation.Id.toString() !== '-1');
  let tempOperationsUI = [];
  for (let i = 0; i < tempOperation.length; i++) {
    tempOperationsUI = AddSequence(tempOperationsUI, defaultSequenceTemplate);
    const operation = tempOperation[i];

    tempOperationsUI[i].Id = operation.Id;
    tempOperationsUI[i].Sequence = operation.Sequence;
    tempOperationsUI[i].Repeat = operation.Repeat;
    tempOperationsUI[i].Repeated = operation.Repeated;
    tempOperationsUI[i].Active = operation.Active;
    tempOperationsUI[i].Running = operation.Running;
    tempOperationsUI[i].TimeElapsed = operation.TimeElapsed;
    tempOperationsUI[i].PressureState.PressureConfig = operation.PressureState.PressureConfig;
    tempOperationsUI[i].PressureState.PressureType = operation.PressureState.PressureType;
    tempOperationsUI[i].SequenceParams = operation.PressureState.ChipTiming;
    tempOperationsUI[i].RepeatType = operation.RepeatType;
    tempOperationsUI[i].RecoveryPreparationState = operation.RecoveryPreparationState;
    // if (operation.PressureState.PressureType === PRESSURE_TYPE.HI) {
    //     tempOperationsUI[i].SequenceParams[PRESSURE_TYPE.HI] = operation.SequenceParams;
    // } else {
    //     tempOperationsUI[i].SequenceParams[PRESSURE_TYPE.LO] = operation.SequenceParams;
    // }

    tempOperationsUI[i].TempRepeat = tempOperationsUI[i].Repeat;
    if (tempOperationsUI[i].RepeatType === RUN_TIME_MODE.MINUTES.VALUE) {
      tempOperationsUI[i].RepeatType = RUN_TIME_MODE.TIMES.VALUE;
      tempOperationsUI[i] = ConvertRepeatModeFromBE(tempOperationsUI[i]);
      tempOperationsUI[i].RepeatType = RUN_TIME_MODE.MINUTES.VALUE;
    }
  }
  consoleLog(
    'ConvertStatusOperationsToEmptyUIOperations',
    operationsBackendStatus,
    indexUI,
    tempOperationsUI,
    tempOperation,
  );
  return tempOperationsUI;
};

const ResetAllSequenceRunning = (operations) => {
  const operationsLength = operations.length;

  for (let i = 0; i < operationsLength; i++) {
    operations[i].Running = false;
  }
  return operations;
};

export const ConvertSequeceNameLabel = (sequence) => {
  let label = '';
  switch (sequence) {
    case SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.PRIME.FE].value:
      label = SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.PRIME.FE].label;
      break;
    case SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.PRIME_BY_SAMPLE.FE].value:
      label = SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.PRIME_BY_SAMPLE.FE].label;
      break;
    case SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.CONCENTRATE.FE].value:
      label = SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.CONCENTRATE.FE].label;
      break;
    case SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.AIR_RECOVERY.FE].value:
      label = SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.AIR_RECOVERY.FE].label;
      break;
    case SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.DIAFILTRATE.FE].value:
      label = SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.DIAFILTRATE.FE].label;
      break;
    case SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.BUFFER_RECOVERY.FE].value:
      label = SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.BUFFER_RECOVERY.FE].label;
      break;
    // MIXING FEATURE F.A.W
    case SEQUENCE_TYPE_ALL[SEQUENCE_TYPE_ALL_ENUM.TUBE_MIXING.FE].value:
      label = SEQUENCE_TYPE_ALL[SEQUENCE_TYPE_ALL_ENUM.TUBE_MIXING.FE].label;
      break;
    // MIXING FEATURE F.A.W
    case SEQUENCE_TYPE_ALL[SEQUENCE_TYPE_ALL_ENUM.RECIRCULATION.FE].value:
      label = SEQUENCE_TYPE_ALL[SEQUENCE_TYPE_ALL_ENUM.RECIRCULATION.FE].label;
      break;
    case SEQUENCE_TYPE_ALL[SEQUENCE_TYPE_ALL_ENUM.PRESSURE_CHANGE.FE].value:
      label = SEQUENCE_TYPE_ALL[SEQUENCE_TYPE_ALL_ENUM.PRESSURE_CHANGE.FE].label;
      break;
    case SEQUENCE_TYPE_ALL[SEQUENCE_TYPE_ALL_ENUM.DEPRESSURIZED_PRESSURE.FE].value:
      label = SEQUENCE_TYPE_ALL[SEQUENCE_TYPE_ALL_ENUM.DEPRESSURIZED_PRESSURE.FE].label;
      break;
    default:
      break;
  }
  return label;
};

export const CalculateOperationTimeRemaining = (operation) => {
  const timeRemainig = ConvertRepeatedToTimeRemaining(operation);
  return ConvertSecondsToHHMMSS(timeRemainig);
};

// return in seconds
export const ConvertRepeatedToTimeRemaining = (operation) => {
  const TimeEachSequence = CalcTimeEachSequence(operation);

  const repeat = operation.Repeat;
  const repeated = operation.Repeated;

  const sequenceRemaining = repeat - repeated;

  const TimeRemainigInMs = sequenceRemaining * TimeEachSequence;
  return TimeRemainigInMs / 1000;
};

// return percentage
export const CalculateOperationPercentage = (operation) => {
  const repeat = operation.Repeat;
  const repeated = operation.Repeated;

  return ((repeated / repeat) * 100).toFixed(0);
};
